function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Share");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M15,0C6.7,0,0,6.7,0,15c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C30,6.7,23.3,0,15,0z M11.5,15 c0,0.2,0,0.5-0.1,0.7l6.1,3.4c1.2-1.1,3-1.2,4.3-0.3c1.5,1.1,1.8,3.2,0.7,4.7c-1.1,1.5-3.2,1.8-4.7,0.7c-0.9-0.6-1.4-1.7-1.4-2.7 c0-0.2,0-0.5,0.1-0.7l-6.1-3.4c-1.2,1.1-3,1.2-4.3,0.2c-1.5-1.1-1.8-3.2-0.7-4.7c1.1-1.5,3.2-1.8,4.7-0.7c0.1,0.1,0.2,0.2,0.3,0.3 l6.1-3.4c-0.1-0.2-0.1-0.5-0.1-0.7C16.4,6.5,18,5,19.8,5c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4c-0.9,0-1.7-0.3-2.3-0.9 l-6.1,3.5C11.5,14.5,11.5,14.8,11.5,15z"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.87c95bca.svg";
export { ForwardRef as ReactComponent };